import { LegalPage } from "@/pages/legal/LegalPage";
import { site } from "@/config/site";

// Modèle à faire relire par un conseil juridique avant publication.
const sections = [
  {
    title: "Éditeur du site",
    content: [
      `Conformément à l'article 6 III de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), il est précisé aux utilisateurs du site <strong>${site.domain}</strong> l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.`,
      `Le site est édité par <strong>${site.name}</strong>, ${site.legalForm} au capital de ${site.capital}, dont le siège social est situé ${site.address.full}, immatriculée au Registre du Commerce et des Sociétés de ${site.rcsCity} sous le numéro ${site.rcsNumber} (EUID : ${site.euid}).`,
      `Numéro de TVA intracommunautaire : ${site.vat}.`,
      `Email : <a href="${site.emailHref}">${site.email}</a> — Téléphone : <a href="${site.phoneHref}">${site.phone}</a>.`,
    ],
  },
  {
    title: "Directeur de la publication",
    content: [`Le directeur de la publication est ${site.president.civility} ${site.president.lastName} ${site.president.firstName}, en qualité de ${site.president.title} de ${site.name}.`],
  },
  {
    title: "Hébergeur",
    content: [
      `Le site est hébergé par <strong>${site.host.name}</strong> — ${site.host.address} — site : <a href="${site.host.url}" target="_blank" rel="noopener noreferrer">namecheap.com</a>.`,
      `L'hébergeur ne communique pas de numéro de téléphone public ; il peut être contacté via son ${site.host.support}.`,
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [
      `L'ensemble des contenus du site (textes, images, logos, graphismes, structure, mise en page) est protégé par le droit d'auteur et le droit de la propriété intellectuelle et demeure la propriété exclusive de ${site.name} ou de ses ayants droit.`,
      `Toute reproduction, représentation, modification, publication, adaptation ou exploitation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de ${site.name}. Toute exploitation non autorisée est constitutive d'une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.`,
      "Les photographies d'illustration proviennent de banques d'images libres de droits et sont utilisées conformément à leurs licences respectives.",
    ],
  },
  {
    title: "Données personnelles",
    content: [`Les traitements de données à caractère personnel réalisés via le site sont décrits dans notre <a href="/politique-de-confidentialite">Politique de confidentialité</a>, à laquelle il convient de se reporter.`],
  },
  {
    title: "Cookies",
    content: [`Les informations relatives aux cookies et traceurs utilisés sur le site, ainsi qu'aux moyens de gérer votre consentement, figurent dans la <a href="/politique-de-confidentialite">Politique de confidentialité</a>. Vous pouvez à tout moment modifier vos choix via le lien « Gérer mes cookies » en pied de page.`],
  },
  {
    title: "Liens hypertextes",
    content: [
      `La mise en place d'un lien hypertexte vers la page d'accueil du site ${site.domain} est autorisée sans accord préalable, sous réserve que le lien ne porte pas atteinte à l'image de ${site.name}, n'utilise pas la technique du « framing » et ne laisse pas entendre un partenariat inexistant. ${site.name} se réserve le droit de demander la suppression de tout lien.`,
      `Les liens sortants vers des sites tiers sont fournis à titre informatif ; ${site.name} n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.`,
    ],
  },
  {
    title: "Droit applicable et juridiction compétente",
    content: ["Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut de résolution amiable, les tribunaux compétents de Bobigny seront seuls compétents, sous réserve des règles d'ordre public applicables."],
  },
];

export default function MentionsLegales() {
  return (
    <LegalPage
      title="Mentions légales | MINES DE PARIS"
      description="Mentions légales du site minesdeparis.world : éditeur MINES DE PARIS (SASU, RCS Bobigny 995 401 502), directeur de la publication, hébergeur Namecheap, propriété intellectuelle et droit applicable."
      path="/mentions-legales"
      crumb="Mentions légales"
      intro="Informations légales relatives à l'éditeur et à l'hébergeur du site, conformément à la loi pour la confiance dans l'économie numérique."
      sections={sections}
    />
  );
}
